import "core-js/proposals/reflect-metadata";
import { jsonProperty, Serializable } from "ts-serializable";

class Statement extends Serializable {
  @jsonProperty(Number, null)
  id: number | null = null;

  @jsonProperty(String)
  name: string = "";

  @jsonProperty(String)
  function: string = "";

  @jsonProperty(String)
  statement: string = "";

  @jsonProperty(String)
  image: string = "";

  @jsonProperty(String)
  imagePath: string = "";

  constructor() {
    super();
  }
}

export default Statement;
